<template>
    <modal name="repairShopSrchPopup" :width="850" :height="500" :clickToClose="false" @before-open="beforeOpen" @opened="opened">
        <div id="div_repairShopSrchPopup" class="popup on">
            <div class="pop_tit">
                수리공장 찾기
            </div>
            <!-- 탭 부분 -->
            <div id="div_repairShopSrchPopupScroll" class="scroll_area pop_con_wrap" style="height:450px;">
                <div class="tab_radio_wrap">
                    <div class="tab_radio">
                        <div class="custom-radio-02">
                            <input type="radio" id="atab01" name="tabs" class="radio" :checked="parentType == ''" v-on:click="selectTabCode({'customerTypeCode':''})"><label for="atab01">전체</label>
                        </div>
                        <div class="custom-radio-02">
                            <input type="radio" id="atab02" name="tabs" class="radio" :checked="parentType == 'CC'" v-on:click="selectTabCode({'customerTypeCode':'CC'})"><label for="atab02">거래처 일반</label>
                        </div>
                        <div class="custom-radio-02">
                            <input type="radio" id="atab03" name="tabs" class="radio" :checked="parentType == '99'" v-on:click="selectTabCode({'customerTypeCode':'99'})"><label for="atab03">보험사</label>
                        </div>
                        <div class="custom-radio-02">
                            <input type="radio" id="atab04" name="tabs" class="radio" :checked="parentType == 'SM'" v-on:click="selectTabCode({'customerTypeCode':'SM'})"><label for="atab04">스피드 메이트</label>
                        </div>
                        <div class="custom-radio-02">
                            <input type="radio" id="atab05" name="tabs" class="radio" :checked="parentType == 'CR'" v-on:click="selectTabCode({'customerTypeCode':'CR'})"><label for="atab05">수리공장</label>
                        </div>
                    </div>
                </div>
                <!-- 검색 부분 -->
                <div class="pop_search_bg bgf7">
                    <div class="input-group-02">
                        <div class="colum-02 col-4">
                            <div class="form_box-02">
                                <label for="cus">거래처명</label>
                                <input type="text" id="cus" class="input-text" placeholder="현대하이카프라자" value="" autocomplete="off"
                                        v-model.lazy.trim="grid_options.general.params.customerName">
                            </div>
                        </div>
                        <div class="colum-02 col-4">
                            <div class="form_box-02">
                                <label for="code">거래처 코드</label>
                                <input type="text" id="code" class="input-text" placeholder="A123456789" value="" autocomplete="off"
                                        v-model.lazy.trim="grid_options.general.params.customerId">
                            </div>
                        </div>
                        <div class="colum-02 col-1">
                            <div class="form_group">
                                <a href="javascript:void(0);" class="account_btn" @click="searchClient">검색</a>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 그리드 부분 -->
                <div class="pop_search_bg" style="height:280px;">
                    <div class="board_list type02">
                        <div class="sub_left_wrap">
                            <div class="btn_area mt0">
                                <a class="button white"><span>거래처 관리</span></a>
                            </div>
                            <div class="destxt vam ml10">
                                거래처의 <span>추가/수정/삭제</span> 마다 조정할 수 있습니다.
                            </div>
                        </div>
                        <grid :options="grid_options" v-once></grid>
                    </div>
                </div>
            </div>
            <!-- 푸터 부분 -->
            <div class="pop_footer_wrap">
                <div class="btn_area mt0">
                    <a href="javascript:void(0);" class="button blue" @click="sendClientData"><span>선택</span></a>
                    <a href="javascript:void(0);" class="button white" @click="close"><span>닫기</span></a>
                </div>
            </div>
            <a href="javascript:void(0);" class="pop_close" title="close" @click="close">close</a>
        </div>
    </modal>
</template>

<script>
import Grid from '@/components/Grid'
import GridModule from '@/modules/grid'
import Vue from 'vue'
import Utils from '@/modules/utils'

export default {
    name : 'repairShopSrchPopup',
    components : { Grid, GridModule, Vue },
    props : {
        value : '',
        options: {
            type: Object,
            default: () => ({})
        }
    },
    data () {
        return {
            //pushToParent: '',
            parentType : '',
            selectedTab : '',
            repairShopInfo : [],
            selectedCode : '',
            grid_options : {
                general : {
                  id  : 'repair-shop-srch-popup-grid',
                  search : '',
                  excel : false,    
                  type : {
                      isUpdate : false,
                      //isHideAdd : true : true,
                  },
                  params : {
                      customerName: '',
                      customerId: '',
                      customerTypeCode: ''
                  }
                },
                grid_options : {
                    height: 216,
                    autoColumnIndex: true,
                    // rowindexColumnFromZero: false,
                    rowSelectOption:{
                        clickSelect: true,
                        singleSelect: true,
                        radioColumn: true,
                        allowSingleUnselect: false
                    },
                    paging: {
                        pagerTotal : false,
                        // hidePageList : false,
                        pagerSelect : false
                    },
                    
                    columnMapping : [
                        //{   key : 'brandId',          hidden: true },
                        //{   width : '30px',            selectorColumn : true   },
                        {   selectorColumn : true ,         title : '선택',           width : '44px',  align : 'center' },
                        {   key : 'customerId',             title : '코드',           width : '150px', align : 'center'  },
                        {   key : 'customerName',           title : '거래처명',        width : '200px', align : 'center'  },
                        {   key : 'customerTypeCodeName',   title : '거래처구분',      width : '150px', align : 'center'  },
                        {   key : 'registrationNumber',     title : '사업자번호',      width : '130px', align : 'center'  },
                        {   key : 'presidentName',          title : '대표자',          width : '100px', align : 'center' , styleclass : "bordr0"  },
                        {   key : 'address',                hidden: true   },
                        {   key : 'addressDetail',          hidden: true   },
                        {   key : 'agentNo',                hidden: true  },
                        {   key : 'zipCode',                hidden: true  }
                    ]
                }
            }
        }
    },
    created() {
        //alert("created");
    },
    mounted () {

    },
    methods : {
        beforeOpen(e) {
            if ( e.params.parentType != undefined && e.params.parentType != null ) {
                this.parentType = e.params.parentType;
            } else {
                this.parentType = '';
            }

            //변수 초기화
            this.repairShopInfo = [];
            this.selectedCode = '';
            this.grid_options.general.search = '';

            Utils.initObject(this.grid_options.general.params, false);

            this.grid_options.general.params.customerTypeCode = this.parentType;
        },
        opened(e) {
            this.searchClient();

            //팝업창 닫기 관련 css 컨트롤(공통)
            $("#div_repairShopSrchPopup").parent().css('overflow', 'visible');
        },
        close() {
            //this.$emit('parts-code-search-slide-complete', {});
            this.$modal.hide('repairShopSrchPopup');
        },
        selectTabCode(tabName) {
            //탭 클릭할 경우 기존 검색파람 초기화
            this.selectedCode = '';
            this.grid_options.general.params.customerName = '';
            this.grid_options.general.params.customerId = '';
            this.grid_options.general.params.customerTypeCode = '';

            //탭 클릭할 경우 기존 그리드 초기화
            $('#' + this.grid_options.general.id).alopexGrid('dataEmpty');
            //탭 클릭시 탭 코드 삽입
            this.selectedCode = tabName;
            //탭 클릭시 조회 구분 코드 삽입
            this.grid_options.general.params.customerTypeCode = this.selectedCode.customerTypeCode; //20 10 ..

            this.searchClient();
        },
        sendClientData(e) {
            //기존 선택된 데이터 초기화
            this.repairShopInfo = [];

            var data = $('#' + this.grid_options.general.id).alopexGrid('dataGet', {_state: {selected:true}});

            console.log(data);

            if(data != null && data != undefined && data != '') {
                for(var key in data) {
                    this.repairShopInfo.push(data[key]);
                }
            }
            //거래처 한개 row를 다 보내는지?
            if(this.repairShopInfo != '' && this.repairShopInfo != undefined && this.repairShopInfo != null) {
                //this.$emit('repair-shop-srch-popup-complete', this.repairShopInfo);
                this.$emit('repair-shop-srch-popup-complete', {parentType: this.parentType, result: AlopexGrid.trimData(this.repairShopInfo[0])});
                this.$modal.hide('repairShopSrchPopup');
            } else {
                Vue.Alert.alert("거래처를 선택해주세요");
                return false;
            }
        },
        searchClient() {
            this.grid_options.general.PageInfo.current = 1;
            this.grid_options.general.search = '/repairshop/list';
            GridModule.searchData(this.grid_options);
        }

    }

}
</script>


// WEBPACK FOOTER //
// src/views/common/RepairShopSrchPopup.vue